// extracted by mini-css-extract-plugin
module.exports = {"extraRunnerInformation":"_e28baff"};